
import { Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

@Injectable()

export class SiteNamePageTitleStrategy extends TitleStrategy {
  constructor(
    public translate: TranslateService,
    private readonly title: Title
  ) {
    super();
  }

  updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    if (title) {
      // this.translate.get(title).subscribe((translatedTitle) => {
      //   console.log(this.translate.get(title))
      //   this.title.setTitle(`Vastmove | ${translatedTitle}`);
      // })
      // this.title.setTitle(`Vastmove | ${title}`)
      this.title.setTitle(`Vastmove | ${this.translate.instant(title)}`)
    } else {
      this.title.setTitle(`Vastmove`);
    }
  }
}
